import {DefaultOptions, QueryClient} from '@tanstack/react-query';

const isE2eBuild = import.meta.env.VITE_E2E === 'true';

export const E2E_STALE_TIME = 60_000;

const queryDefaults: NonNullable<DefaultOptions['queries']> = {
  refetchOnWindowFocus: false,
  retry: false, // disabled in favor of ky's retry mechanism
};

if (isE2eBuild) {
  queryDefaults.refetchInterval = false;
  queryDefaults.retry = 0;
  queryDefaults.staleTime = E2E_STALE_TIME;
  queryDefaults.refetchOnMount = (query) => query.state.isInvalidated;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: queryDefaults,
  },
});

export const e2eFetchQueryOptions: {staleTime?: number} = isE2eBuild ? {staleTime: E2E_STALE_TIME} : {};
